module.exports = __webpack_public_path__ + "img/yaoqing_wenzi.86601c6f.png";